import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Home from './Component/pages/Home';
import Services from './Component/Services/Services';
import ContactUs from './Component/ContactUs/ContactUs';
import React from "react";
// import { IoIosArrowUp } from "react-icons/io";

import HomeScreen from './Component/Template02/HomeScreen/HomeScreen'
import AboutScreen from './Component/Template02/AboutScreen/AboutScreen'
import ServicesPage from './Component/Template02/ServicesPage/ServicesPage'
import Gallery from './Component/Template02/Gallery/Gallery'
import ContactPage from './Component/Template02/ContactPage/ContactPage'


function App() {
  // const [isVisible, setIsVisible] = useState(false);

  // const goToBtn = () => {
  //   window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  // };

  // const listenToScroll = () => {
  //   let heightToHidden = 250;
  //   const winScroll =
  //     document.body.scrollTop || document.documentElement.scrollTop;

  //   if (winScroll > heightToHidden) {
  //     setIsVisible(true);
  //   } else {
  //     setIsVisible(false);
  //   }
  // };

  // useEffect(() => {
  //   window.addEventListener("scroll", listenToScroll);
  //   return () => window.removeEventListener("scroll", listenToScroll);
  // }, []);

  return (
    <BrowserRouter>
      <Routes>        
        <Route path='/template2/' element={<Home />} />
        <Route path='/template2/services' element={<Services />} />
        <Route path='/template2/contactus' element={<ContactUs />} />

        <Route path='/' element={<HomeScreen />} />
        <Route path='/about' element={<AboutScreen />} />
        <Route path='/services' element={<ServicesPage />} />
        <Route path='/gallery' element={<Gallery />} />
        <Route path='/contact' element={<ContactPage />} />

      </Routes>
      {/* {isVisible && (
        <div className="top-btn" onClick={goToBtn}>
          <IoIosArrowUp className="top-btn-icon" />
        </div>
      )} */}
    </BrowserRouter>
  );
}

export default App;
